import React, { Component } from 'react';
import { Toast } from 'primereact/toast';


import Server from '../Server.js'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { SelectButton } from 'primereact/selectbutton';
import { connect } from 'react-redux';
import { Loader } from 'rsuite';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
const FilterItems = [
  { label: '10', value: '10' },
  { label: '100', value: '100' },
  { label: '500', value: '500' },
  { label: '1000', value: '1000' }
];
class MehrCartRaymand extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();
    this.FieldRef = React.createRef();
    this.selectedLaonChange = this.selectedLaonChange.bind(this);
    this.toast = React.createRef();
    this.state = {
      layout: 'list',
      name: "",
      type: "1",
      FId: "",
      DbTableName: "",
      DBTableField: "",
      confirm:false,
      active:false,
      Filter:"10",
      absoluteUrl: this.Server.getAbsoluteUrl(),
      url: this.Server.getUrl(1)
    }
  }
  selectedLaonChange(value) {
    this.setState({
      selectedName: value.name,
      SelectedMobile: value.mobile,
      selectedPhone: value.phone,
      selectedAcc: value.number,
      SelectedCode: value.CodeMelli,
      SelectedCartPic: value.CartMelli_Pic,
      SelectedSign: value.sign,
      Authentication_Pic: value.Authentication_Pic,
      SelectedShenasnameCode : value.ShenasnameCode,
      SelectedFatherName : value.fatherName,
      SelectedAddress: value.address,
      SelectedBirthDay: value.BirthDay,
      SelectedJob : value.job,
      SelectedCity : value.city,
      SelectedJobCity : value.jobCity,
      selectedUId: value.UId,
      SelectedId : value._id,
      SelectedStatus : value.status,
      OldStatus : value.status,
      selectedDescription : value.desc||"",
      VisibleDialog:true
    })
  }
  componentDidMount() {
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1
    })
    let that = this;
    let SCallBack = function (response) {
      that.setState({
        user_Id: response.data.authData.userId,
        loading: 0
      })
      that.GetAccs("10");

    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0
      })
      console.log(error)
    }
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack)
  }
  onHideReserveDialog(event) {
    this.setState({
      visibleManageField: false,
      selectedId: null
    });

  }
 
  GetAccs(Filter) {
    let that = this;
    /*let param = {
      token: localStorage.getItem("api_token"),
      condition: Filter != "All" ? {status:parseInt(Filter)} : {status:{$in:[0,1,-1]}} 
    };*/
    this.setState({
      loading: 1
    })
    let ListView=[];
    let MandeArray=[];      
    let DateArray=[];                 
    let SCallBack = function(response){            
      that.setState({ 
        ShowLoading:false
      }) 
      let data=[];
      let resp=[];
      
     for(let i=0;i<response.length;i++){
       resp[i] = response[i].children;
      
     }  
     var count=0;
     for(let i=0;i<resp.length;i++){
          data.push(resp[i])
          count++;
     }    
     let GridData=[];
     for(let i=0;i<data.length;i++){
     let Hr = data[i][1] ? data[i][1].value : ""; 
     Hr = Hr.substring(0,2) + ":"+ Hr.substring(2,4) + ":" + Hr.substring(4,6);
     let Date = data[i][0] ? data[i][0].value : "";  
     let Bes = data[i][2] ? data[i][2].value : "0"; 
     let Bed = data[i][3] ? data[i][3].value : "";  
     let Mnd = data[i][5] ? data[i][5].value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "";                
     let SanadNo = data[i][6] ? data[i][6].value : "";    
     let Des = data[i][7] ? data[i][7].value : ""; 
     let Info = data[i][8] ? data[i][8].value : "";           
          
     let Typ  = (Bes=="0") ? <span style={{fontFamily:'iranyekanwebmedium',fontSize:13,color:'red'}}><i name='ios-arrow-round-down' style={{fontSize:13,color:'red'}} />برداشت</span> : <span style={{fontFamily:'iranyekanwebmedium',fontSize:13,color:'green'}}><i name='ios-arrow-round-up' style={{fontSize:13,color:'green'}}  />واریز</span> ;
     let Amount = (Bes!="0")	? Bes.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : Bed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
     GridData.push({
      Hr:Hr,
      Date: Date,
      Amount: Amount,
      Mnd:Mnd,
      SanadNo: SanadNo,
      Des: Des,
      Info: Info,
      Typ:Typ
     })
       
     }
      that.setState({
        GridData:GridData,
        loading:false
      })
     
    } 
    let ECallBack = function(error){
      that.setState({   
        loading:false
      })  
     alert(error)   
    }
    //111653614
    var param = '{CommandNo : "2" , AccountNo: "111653614",Param1: "'+Filter+'" }';
    this.setState({
      ShowLoading:true
    }) 
    let ip = that.props.ip || "https://ansar24.com";
    that.Server.sendRaymand("https://ansar24.com/MobileBank.aspx/MobileBankSp",param,SCallBack,ECallBack,0)
  }
  EditAcc(){
    let that = this;
    
    
    let msg = "";
    if(this.state.SelectedStatus == "1" && !this.state.selectedAcc){
      that.toast.current.show({ severity: 'warn', summary: <div> شماره حساب را وارد کنید </div>, life: 8000 });
      return;
    }
    if(this.state.SelectedStatus == "-1")
      msg = "درخواست افتتاح حساب شما توسط سیستم رد شده است . برای افتتاح حساب مجدد میتوانید به اپلیکیشن مراجعه کنید" + "\n" + this.state.selectedDescription||""  + "\n" ;
    if(this.state.SelectedStatus == "1")
      msg = "حساب شما در صندوق انصار الهدی ایجاد شد " + "\n" + "شماره حساب : " + this.state.selectedAcc +  + "\n" + this.state.selectedDescription||"" + "\n" ;
    that.setState({
        loading: 1
    })
    let param = {
      token: localStorage.getItem("api_token"),
      mobile: this.state.SelectedMobile,
      name: this.state.selectedName,
      number: this.state.selectedAcc,
      _id: this.state.SelectedId,
      desc: this.state.selectedDescription||"",
      status: parseInt(this.state.SelectedStatus),
      CodeMelli: this.state.SelectedCode,
      phone: this.state.selectedPhone,
      ShenasnameCode : this.state.SelectedShenasnameCode,
      fatherName : this.state.SelectedFatherName,
      address: this.state.SelectedAddress,
      BirthDay: this.state.SelectedBirthDay,
      job : this.state.SelectedJob,
      city : this.state.SelectedCity,
      jobCity : this.state.SelectedJobCity,
      OldStatus: parseInt(this.state.OldStatus),
      msg:msg,
      EditByAdmin:true
    };
    let SCallBack = function (response) {
      that.setState({
        loading: 0,
        SelectedId:null
      })
      that.GetAccs(that.state.Filter);
      that.toast.current.show({ severity: 'success', summary: <div> عملیات با موفقیت انجام شد </div>, life: 8000 });

    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0
      })
      that.toast.current.show({ severity: 'error', summary: <div> عملیات انجام نشد </div>, life: 8000 });
      console.log(error)
    }
    this.Server.send("AdminApi/EditAccountReq", param, SCallBack, ECallBack)


  }
  render() {
   

 
    return (

      <div style={{ direction: 'rtl' }}>
        {this.state.loading == 1 &&
          <div style={{ position: 'fixed', zIndex: 2000, top: 10, left: 15, backgroundColor: '#e89f31', padding: '2px 20px' }}>
            <Loader content="لطفا صبر کنید ..." className="yekan" />
          </div>
        }

        <Toast ref={this.toast} position="bottom-left" style={{ fontFamily: 'YekanBakhFaBold', textAlign: 'right' }} />
        <p className="mt-5" style={{textAlign:'center',fontSize:30}}>حساب مهرکارت رایمند (111653614)</p>

        <div style={{ textAlign: 'right', marginBottom: 10,marginTop:20 }}>
              <SelectButton value={this.state.Filter} options={FilterItems} style={{ fontFamily: 'Yekan' }} className="yekan" onChange={(e) => { 
                if(e.value != null){
                  this.setState({ Filter: e.value }); this.GetAccs(e.value)
                }
                }}></SelectButton>

        </div>
        <div className="row justify-content-center">

          <div className="col-12" style={{ background: '#fff' }}>
           
            <div className="section-title " style={{ textAlign: 'right' }}><span className="title IRANYekan" style={{ fontSize: 17, color: 'gray' }} >لیست تراکنش های حساب رایمند</span></div>
         
            <DataTable responsive value={this.state.GridData} selectionMode="single" selection={this.state.selectedLaon} onSelectionChange={e => { this.selectedLaonChange(e.value) }} >
             

              <Column field="Typ" header="نوع تراکنش" className="irsans" style={{ textAlign: "right" }} />
              <Column field="Amount" header="مبلغ" className="irsans" style={{ textAlign: "right" }} />
              <Column field="Mnd" header="مانده" className="irsans" style={{ textAlign: "right" }} />
              <Column field="Hr" header="ساعت" className="irsans" style={{ textAlign: "right" }} />
              <Column field="Date" header="روز" className="irsans" style={{ textAlign: "right" }} />
              <Column field="Des" header="توضیح" className="irsans" style={{ textAlign: "right" }} />
              <Column field="SanadNo" header="سند" className="irsans" style={{ textAlign: "right" }} />

            </DataTable>
          </div>

        </div>

        <Dialog header="جزئیات درخواست" visible={this.state.SelectedId} style={{ width: '80vw' }} minY={70} onHide={()=>{
          this.setState({
            SelectedId:null
          })
        }} maximizable={true} maximized={true}>
          <div style={{ overflowY: 'auto', overflowX: 'hidden', minHeight: 400 }}>
            
          <div className="row" style={{ background: '#fff', borderRadius: 10, padding: 20, textAlign: 'right',alignItems:'baseline' }}>
                <div className="col-lg-3">
                              <label className="labelNoGroup irsans">وضعیت</label>
                              <select className="form-control irsans" id="company" name="company" value={this.state.SelectedStatus} onChange={(event) => {
                                this.setState({SelectedStatus: event.target.value }) 
                                }} style={{ marginBottom: 20 }} >
                                <option value="-1">عدم تایید</option>
                                <option value="0">درخواست اولیه</option>
                                <option value="1">تایید نهایی</option>
                              </select>
                    </div>
                  <div className="col-lg-12">
                    <div className="group">
                      <input className="form-control YekanBakhFaBold" autoComplete="off" type="text" value={this.state.selectedAcc} name="selectedAcc" onChange={(event)=>this.setState({ selectedAcc: event.target.value })} style={{ textAlign: 'right' }} required="true" />
                      <label>شماره حساب صندوق</label>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="group">
                      <input className="form-control YekanBakhFaBold" autoComplete="off" type="text" value={this.state.selectedName} name="selectedName" onChange={(event)=>this.setState({ selectedName: event.target.value })} style={{ textAlign: 'right' }} required="true" />
                      <label>نام و نام خانوادگی</label>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="group">
                      <input className="form-control YekanBakhFaBold" autoComplete="off" type="text" value={this.state.SelectedCode} name="SelectedCode" onChange={(event)=>this.setState({ SelectedCode: event.target.value })} style={{ textAlign: 'right' }} required="true" />
                      <label>کد ملی</label>
                    </div>
                  </div>
                  
                  
                  <div className="col-lg-6">
                    <div className="group">
                      <input className="form-control YekanBakhFaBold" autoComplete="off" type="text" value={this.state.selectedPhone} name="selectedPhone" onChange={(event)=>this.setState({ selectedPhone: event.target.value })} style={{ textAlign: 'right' }} required="true" />
                      <label>تلفن ثابت</label>
                    </div>
                  </div>

                  
                  <div className="col-lg-6" >
                    <div className="group">
                      <input className="form-control YekanBakhFaBold" autoComplete="off" type="text" value={this.state.SelectedMobile} name="SelectedMobile" onChange={(event)=>this.setState({ SelectedMobile: event.target.value })} style={{ textAlign: 'right' }} required="true" />
                      <label>موبایل</label>
                    </div>
                  </div>
                  
                  <div className="col-lg-6" >
                    <div className="group">
                      <input className="form-control YekanBakhFaBold" autoComplete="off" type="text" value={this.state.SelectedShenasnameCode} name="SelectedShenasnameCode" onChange={(event)=>this.setState({ SelectedShenasnameCode: event.target.value })} style={{ textAlign: 'right' }} required="true" />
                      <label>شماره شناسنامه</label>
                    </div>
                  </div>
                  <div className="col-lg-6" >
                    <div className="group">
                      <input className="form-control YekanBakhFaBold" autoComplete="off" type="text" value={this.state.SelectedFatherName} name="SelectedFatherName" onChange={(event)=>this.setState({ SelectedFatherName: event.target.value })} style={{ textAlign: 'right' }} required="true" />
                      <label>نام پدر</label>
                    </div>
                  </div>
                  <div className="col-lg-6" >
                    <div className="group">
                      <input className="form-control YekanBakhFaBold" autoComplete="off" type="text" value={this.state.SelectedBirthDay} name="SelectedBirthDay" onChange={(event)=>this.setState({ SelectedBirthDay: event.target.value })} style={{ textAlign: 'right' }} required="true" />
                      <label>تاریخ تولد</label>
                    </div>
                  </div>

                  
                  <div className="col-lg-6" >
                    <div className="group">
                      <input className="form-control YekanBakhFaBold" autoComplete="off" type="text" value={this.state.SelectedJob} name="SelectedJob" onChange={(event)=>this.setState({ SelectedJob: event.target.value })} style={{ textAlign: 'right' }} required="true" />
                      <label>شغل</label>
                    </div>
                  </div>
                  <div className="col-lg-6" >
                    <div className="group">
                      <input className="form-control YekanBakhFaBold" autoComplete="off" type="text" value={this.state.SelectedJobCity} name="SelectedJobCity" onChange={(event)=>this.setState({ SelectedJobCity: event.target.value })} style={{ textAlign: 'right' }} required="true" />
                      <label>شهر محل کار</label>
                    </div>
                  </div>
                  <div className="col-lg-6" >
                    <div className="group">
                      <input className="form-control YekanBakhFaBold" autoComplete="off" type="text" value={this.state.SelectedCity} name="SelectedCity" onChange={(event)=>this.setState({ SelectedCity: event.target.value })} style={{ textAlign: 'right' }} required="true" />
                      <label>شهر محل سکونت</label>
                    </div>
                  </div>
                  <div className="col-lg-12" >
                    <div className="group">
                      <input className="form-control YekanBakhFaBold" autoComplete="off" type="text" value={this.state.SelectedAddress} name="SelectedAddress" onChange={(event)=>this.setState({ SelectedAddress: event.target.value })} style={{ textAlign: 'right' }} required="true" />
                      <label>آدرس</label>
                    </div>
                  </div>


                  <div className="col-lg-12" >
                    <div className="group">
                      <input className="form-control YekanBakhFaBold" autoComplete="off" type="text" value={this.state.selectedDescription} name="selectedDescription" onChange={(event)=>this.setState({ selectedDescription: event.target.value })} style={{ textAlign: 'right' }} required="true" />
                      <label>توضیح</label>
                    </div>
                  </div>
                  
                  

                  <div className="col-lg-12" style={{ textAlign: 'right' }}>
                    <Button style={{ marginLeft: 5, marginTop: 10 }} color="primary" onClick={()=>this.EditAcc()}>ویرایش درخواست</Button>

                  </div>

                  <div className="col-lg-12" style={{marginTop:50}}>
                    
                    <div>
                      مدارک بارگزاری شده


                      <div>

                <div className="row" style={{alignItems:'baseline',backgroundColor:"aliceblue"}}>
                    <div className="col-4">
                    <label> کپی کارت ملی : </label>
                      <img src={this.state.SelectedCartPic} style={{width:"100%"}} id="Authentication_Pic" name="Authentication_Pic" />
                    </div>
                    <div className="col-4">
                    <label> تصویر اهراز هویت : </label>
                      <img src={this.state.Authentication_Pic} style={{width:"100%"}} id="Authentication_Pic" name="Authentication_Pic" />
                    </div>
                    <div className="col-4">
                    <label> نمونه امضا : </label>
                      <img src={this.state.SelectedSign} style={{width:"100%"}} id="Authentication_Pic" name="Authentication_Pic" />
                    </div>
                    

                </div>
                </div>
                </div>

                   
                    
                  </div>





                </div>

          </div>
          
        </Dialog>


      </div>





    )
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  }
}
export default   connect(mapStateToProps)(MehrCartRaymand);
